<template>
  <div style="width: 100%;height: 100%; overflow: auto; margin: auto">
  <el-form :model="formData" style="margin: 20px" label-width="120px">
    <el-form-item label="维修中心：">
      <el-select v-model="formData.bu_id" disabled>
        <el-option v-for="item in buList" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="快递单号：">
      <el-input v-model="formData.logistics_no" disabled></el-input>
    </el-form-item>
    <el-form-item label="物料信息：">
      <el-row style="width: 100%">
        <el-col :span="7" class="title_class">物料描述</el-col>
        <el-col :span="3" class="title_class">库区类型</el-col>
        <el-col :span="3" class="title_class">调配数量</el-col>
        <el-col :span="3" class="title_class">实际收货数量</el-col>
        <el-col :span="5" class="title_class">入库库位</el-col>
        <el-col :span="3" class="title_class">备注</el-col>
      </el-row>
      <el-row v-for="inTransitItem in formData.inTransitItemList" style="width: 100%;margin-bottom: 5px" >
        <el-col :span="7" class="item_class">
          <el-select v-model="inTransitItem.material_id" disabled>
            <el-option v-for="item in materialList" :key="item.id" :label="item.name" :value="item.id" > </el-option>
          </el-select>
        </el-col>
        <el-col :span="3" class="item_class">
          <el-select v-model="inTransitItem.material_type" disabled>
            <el-option v-for="item in materialTypeList" :key="item.value" :label="item.name" :value="item.value"></el-option>
          </el-select>
        </el-col>
        <el-col :span="3" style="text-align: center">
          <el-input-number style="width: 80%" v-model="inTransitItem.assign_cnt" min="0" :controls="false" disabled></el-input-number>
        </el-col>
        <el-col :span="3" style="text-align: center">
          <el-input-number style="width: 80%" v-model="inTransitItem.receive_cnt" min="0" :controls="false" ></el-input-number>
        </el-col>
        <el-col :span="5" class="item_class">
          <el-select v-model="inTransitItem.position_id" >
            <el-option v-for="item in inTransitItem.positionList" :key="item.value" :label="item.label" :value="item.value" ></el-option>
          </el-select>
        </el-col>
        <el-col :span="3" class="item_class">
          <el-input v-model="inTransitItem.remark"></el-input>
        </el-col>
      </el-row>
    </el-form-item>
    <el-form-item label="备注：">
      <el-input v-model="formData.remark" type="textarea" rows="3" disabled></el-input>
    </el-form-item>
    <el-form-item>
      <el-button :loading="loading" @click="checkIn">入库</el-button>
    </el-form-item>
  </el-form>

  </div>

</template>

<script>
export default {
  name: "WmsInTransitCheckIn",
  inject: ['$fn'],

  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  computed: {
    materialTypeList() {
      return this.$store.getters['core/getDictList']('wms_area_type');
    },
  },

  data() {
    return {
      buList: [],
      materialList:[],
      formData: {},
      loading: false
    }
  },

  async created() {
    await this.getBuList();
    await this.initData();
    await this.getMaterialList();
  },
  methods: {
    async initData(){
      this.formData.id = this.parentData.id;
      this.formData.bu_id = this.parentData.bu_id;
      this.formData.logistics_no = this.parentData.logistics_no;
      let params = {
        id: this.parentData.id,
        bu_id: this.parentData.bu_id,
      }
      this.formData.inTransitItemList = await this.$http('wmsInTransitService.getInTransitCheckInList',params);
      this.formData.remark = this.parentData.remark;
    },

    //获取物料
    async getMaterialList() {
      this.materialList = await this.$http('baseMaterialService.getAllMaterial',{});
    },
    //获取维修中心
    async getBuList(){
      this.buList = await this.$http('wmsDsService.getAllRepairCenter',{});
    },

    //入库
    async checkIn() {
      //校验
      let i = 1;
      for (let item of this.formData.inTransitItemList) {
        if(item.receive_cnt === undefined){
          this.$message.error('第' + i + '行收货数量为空');
          return;
        }
        if(item.position_id === undefined){
          this.$message.error('第' + i + '行库位为空');
          return;
        }
        i++;
      }
      this.loading = true;
      await this.$http('wmsInTransitService.inTransitCheckIn', this.formData);
      this.$message.success('入库成功');
      this.loading = false;
      this.$fn.search();
      this.$fn.closeWindow();
    }

  },


}
</script>

<style scoped>

.title_class{
  margin-bottom: 5px;
  background-color: lightgray;
  height: 35px;
  line-height: 35px;
  text-align: center;
}

.item_class{
  padding-left: 5px;
  padding-right: 5px;
}

.option-label {
  display: inline-block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

</style>